<app-spinner *ngIf="isEnrolling"></app-spinner>
<div *ngIf="(guardian.students.length==0 || guardian.students.length==1) && !isEnrolling" id="show-guardian" class="row" role="main">
    <div   class="col-sm-12">
    <div class="card">
        <h4 class="card-header text-center">Welcome - Bold Learning</h4>
        <div class="text-center mt-5">
          <img src="/assets/images/motivator.png" width="50%">
        </div>
        <div class="col-sm-6 offset-sm-3 mt-5 mb-3">
          <h4 class ="text-center">Steps to complete set up</h4>
         <table class="table">
           <tr *ngIf="guardian.students.length==0">
             <td>1</td>
             <td>
               <fieldset class ="text-center" *ngIf="guardian.students.length==0">
               <a  (click)="addStudentRegistrationPopup()"
                  class="btn btn-outline-primary btn-block"><i class='fa fa-user-plus'></i> Register New Student
               </a>
               </fieldset>
             </td>
             <td>pending</td>
          </tr>
          <tr *ngIf="guardian.students.length==1">
            <td>1</td>
            <td><button class="btn btn-outline-secondary btn-block disabled mb-2"><i class='fa fa-user-plus'></i> Register New Student</button></td>
            <td>done</td>
         </tr>
         <tr *ngIf="guardian.students.length==0">
             <td>2</td>
             <td><button class="btn btn-outline-secondary btn-block disabled mt-2">Create Quiz</button></td>
             <td>pending</td>
         </tr>
         <tr *ngIf="guardian.students.length==1">
          <td>2</td>
          <td>
            <button class="btn btn-outline-primary btn-block my-3"
            (click)="addTrialEnrolmentPopup()" >
                <span *ngIf="!firstQuizLoading">
                  <i class="fa fa-thumbs-o-up"></i> Create  Quiz
                </span>

                <span *ngIf="provisioning">
                  <i class="fa fa-thumbs-o-up"></i> Create  Quiz 1 of 2
                  <span *ngIf="loading" class="spinner-border spinner-border-lg me-1 text-info"></span>
                </span>
                <span *ngIf="invoicing">
                  <i class="fa fa-thumbs-o-up"></i> Create  Quiz  2 of 2
                  <span *ngIf="loading" class="spinner-border spinner-border-lg me-1 text-info"></span>
                </span>

            </button>
          </td>
          <td><i class="fa fa-times-circle text-success"></i></td>
      </tr>
         </table>

        </div>


      </div>
    </div>
    <span *ngIf="studentDetail">
      <app-enrol-trial *ngIf="!(studentDetail.is_premium_ready==1  && guardian)"
      [studentDetail]="studentDetail"
      [guardian]="guardian"
      (provisioning)="alertProvisioning($event)"
      (enrolLoading)="toggleTrialEnrolLoading($event)"
      (closeModalRequest)="closeModal($event)"></app-enrol-trial>
    </span >



    <app-register-student [guardian]="guardian"
    (closeModalRequest)="closeModal($event)"
    (notificationRegFinished)="reloadMainHomePage($event)"
    ></app-register-student>
    </div>
